// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Generated from annotationui.unscoped.css — edit that file, then run: npm run scope-css */
/**
 * OpenSeadragon paperjs overlay plugin based on paper.js
 * @version 0.7.6
 * 
 * Includes additional open source libraries which are subject to copyright notices
 * as indicated accompanying those segments of code.
 * 
 * Original code:
 * Copyright (c) 2022-2026, Thomas Pearce
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * 
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 * 
 * * Neither the name of osd-paperjs-annotation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 */
/* Edit this file, then run: npm run scope-css (writes annotationui.css with .osd-paperjs-annotation scope). */
body.annotation-ui-noselect{
    user-select:none;
}
.osd-paperjs-annotation .ui-dialog{
    font-size:14px;
}
.osd-paperjs-annotation .ui-dialog, .osd-paperjs-annotation .ui-dialog-content {
    box-sizing: content-box;
}
.osd-paperjs-annotation .flex-row{
    display:flex;
    flex-direction:row;
}
.osd-paperjs-annotation .annotation-ui-mainwindow .templates{
    display:none;
}
.osd-paperjs-annotation .annotation-ui-mainwindow{
    height:100%;
    width:16em;
    min-width:12em;
    color:black;
    overflow:hidden;
    display:grid;
    grid-template-rows: auto auto minmax(4em, 1fr) auto;
    border:thin gray solid;
    padding:2px;
    box-sizing:border-box;
}
.osd-paperjs-annotation .annotation-visibility-controls{
    display:flex;
    flex-grow:0;
    flex-shrink:0;
    border-bottom:thin gray solid;
    padding-bottom:2px;
    margin-bottom:2px;
}
.osd-paperjs-annotation .annotation-visibility-controls .visibility-buttons{
    flex-grow:0;
    display:flex;
    margin-right:5px;
}
.osd-paperjs-annotation .annotation-visibility-controls .annotation-opacity-container{
    flex-grow:1;
}
.osd-paperjs-annotation .annotation-ui-mainwindow button.btn{
    padding:0 3px;
}
.osd-paperjs-annotation .file-button{
    padding:0.1em 0.5em;
    margin-right:0.3em;
}
.osd-paperjs-annotation .annotation-ui label{
    margin:0;
}
.osd-paperjs-annotation .annotation-ui-feature-collections{
    overflow:auto;
    border-bottom:thin gray solid;
}
.osd-paperjs-annotation .annotation-ui-feature-collections:empty::before {
    content: 'Click below to begin a new feature collection';
    color: gray;
}
.osd-paperjs-annotation .feature-collection{
    border: thin transparent solid;
    padding:2px;
    opacity:0.1;
}
.osd-paperjs-annotation .annotation-ui-feature-collections .feature-collection{
    transition: opacity 1s;
}
.osd-paperjs-annotation .annotation-ui-feature-collections .feature-collection.inserted:not(.trashed):not(.draganddrop-dragging){
    opacity:1;
}
.osd-paperjs-annotation .annotation-ui-feature-collections .feature-collection:not(.trashed).selected{
    border:thin black solid;
    background-color:azure;
} 
.osd-paperjs-annotation .annotation-ui-feature-collections
    .feature-collection:not(.trashed,.annotation-hidden,.selected):hover,.osd-paperjs-annotation .feature-collection.svg-hovered:not(.trashed):not(.annotation-hidden){
    background-color:lightgoldenrodyellow;
    border:thin black solid;
}
.osd-paperjs-annotation .feature-collection.annotation-hidden [data-action="hide"]{
    display:none;
}
.osd-paperjs-annotation .feature-collection:not(.annotation-hidden) [data-action="show"]{
    display:none;
}
.osd-paperjs-annotation .feature-collection.annotation-hidden .features{
    pointer-events:none;
    opacity:50%;
}
.osd-paperjs-annotation .annotation-ui-feature-collections .name{
    font-weight:bold;
}
.osd-paperjs-annotation .annotation-details{
    flex-grow:1;
}
.osd-paperjs-annotation .feature-item{
    margin-left:1em;
}

.osd-paperjs-annotation .feature-collection [data-action], .osd-paperjs-annotation .feature [data-action]{
    margin-left:0.2em;
}
.osd-paperjs-annotation .hoverable-actions:not(:hover) .onhover{
    visibility:hidden;
}
.osd-paperjs-annotation .hoverable-actions:hover .editablecontent .onhover {
    visibility:visible;
}
.osd-paperjs-annotation .feature-collection.trashed{
    background-color:darkred;
    opacity:0.3;
    pointer-events:none;
}
.osd-paperjs-annotation .annotation-header{
    display:grid;
    grid-template-columns:auto 1fr auto auto auto;
}
.osd-paperjs-annotation .feature-collection.trashed .annotation-header [data-action="trash"]{
    pointer-events:all;
    visibility:visible;
}
.osd-paperjs-annotation .feature-collection .toggle-list{
    flex-grow:0
}
.osd-paperjs-annotation .feature-collection .features{
    flex-grow:1;
}
.osd-paperjs-annotation .features.collapsed .features-list{
    display:none;
}
.osd-paperjs-annotation .features:not(.collapsed) .features-summary{
    display:none;
}
.osd-paperjs-annotation .features.collapsed [data-action="collapse-up"]{
    display:none;
}
.osd-paperjs-annotation .features:not(.collapsed) [data-action="collapse-down"]{
    display:none;
}
.osd-paperjs-annotation .features-summary:not([data-num-elements="1"]) .pluralize::before{
    content:'s';
}
.osd-paperjs-annotation .feature.selected{
    background-color:green;
}
.osd-paperjs-annotation .feature{
    cursor:default;
}
.osd-paperjs-annotation .annotation-ui-mainwindow.disabled .disable-when-annotations-hidden{
    opacity:0.5;
    pointer-events:none;
    cursor:not-allowed;
}
.osd-paperjs-annotation .annotation-ui-mainwindow.deactivated .disable-when-deactivated{
    opacity:0.5;
    pointer-events:none;
    cursor:not-allowed;
}

.osd-paperjs-annotation .annotation-ui-grid{
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: auto 1fr auto;
    width: 100%;
    height: 100%;
    background-color:white;
}
.osd-paperjs-annotation .annotation-ui-grid .center{
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    position:relative;
    z-index:0; /* reset the z-index basis for this container so children can be manipulated independently of siblings */
}
.osd-paperjs-annotation .annotation-ui-grid .top {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    text-align:center;
    border-bottom:thin gray solid;
}
.osd-paperjs-annotation .annotation-ui-grid .bottom {
    grid-column: 1 / 3;
    grid-row: 3 / 4;
}
.osd-paperjs-annotation .annotation-ui-grid .left {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
}
.osd-paperjs-annotation .annotation-ui-grid .right {
    grid-column: 3 / 4;
    grid-row: 1 / 4;
    position:relative;
}
/* Scope wrapper fills the grid cell so .annotation-ui-mainwindow { height: 100% } works */
.annotation-ui-grid .right > .osd-paperjs-annotation {
    height: 100%;
}
.osd-paperjs-annotation .annotation-ui-grid .resize-right{
    width: 15px;
    left: -15px;
    position: absolute;
    background-color: rgb(196, 196, 196);
    cursor: grab;
    text-align:center;
    user-select:none;
    top:50%;
    transform: translate(0, -50%);
    padding:10px 0;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.osd-paperjs-annotation .annotation-ui-grid .resize-right::before{
    content:'||';
}
.osd-paperjs-annotation .annotation-ui-grid .resize-right.resizing{
    cursor:grabbing;
}
.osd-paperjs-annotation .annotation-ui-grid .right:not(:hover) .resize-right{
    display:none;
}

.osd-paperjs-annotation .annotation-ui-drawing-toolbar .pseudohidden, .osd-paperjs-annotation .annotation-ui-drawing-toolbar .invisible{
    visibility:hidden;
    width: 0;
    height: 0;
    overflow: hidden;
    padding:0;
    border:none;
}
.osd-paperjs-annotation .annotation-ui-drawing-toolbar{
    background-color:lightgray;
    display: inline-block;
    max-width:100%;
    text-align:left;
}
.osd-paperjs-annotation .annotation-ui-drawing-toolbar button[disabled]{
    pointer-events:none;
    cursor:not-allowed;
    border:thin solid transparent;
}
.osd-paperjs-annotation .annotation-ui-drawing-toolbar button:not([disabled]){
    border:thin rgb(195, 195, 195) solid;
}
.osd-paperjs-annotation .annotation-ui-drawing-toolbar button:not([disabled]):hover{
    border:thin rgb(41, 41, 41) solid;
    z-index:2;
}
.osd-paperjs-annotation .annotation-ui-drawing-toolbar .dropdowns>*:not(.active){
    display:none;
}
.osd-paperjs-annotation .annotation-ui-buttonbar>.btn.active{
    color:black;
    background-color:darkgray;
}
.osd-paperjs-annotation .annotation-ui-buttonbar>.btn:not(.active){
    color:rgb(62, 62, 62);
    background-color:lightgrey;
}
.osd-paperjs-annotation .dropdowns-container{
    position:relative;
    background-color:inherit;
}
.osd-paperjs-annotation .dropdowns{
    color:black;
    position:absolute;
    background-color:inherit;
    min-width:100%;
}
.osd-paperjs-annotation .dropdowns:has(.dropdown.active .ruler-toolbar) { min-width: 280px; }
.osd-paperjs-annotation .dropdowns:has(.dropdown.active .linestring-toolbar) { min-width: 280px; }
.osd-paperjs-annotation .dropdowns:has(.dropdown.active .brush-toolbar) { min-width: 280px; }
.osd-paperjs-annotation .dropdown{
    width:100%;
    display:grid;
    vertical-align: middle;
    column-gap:1em;
    grid-template-columns:auto;
}
/* brush-toolbar styles */
.osd-paperjs-annotation .dropdown.brush-toolbar{
    grid-template-columns: auto minmax(8em, 1fr) auto auto;    
}
/* end brush-toolbar styles */

/* polygon-toolbar styles */
.osd-paperjs-annotation .dropdown.polygon-toolbar{
    grid-template-columns: 1fr auto auto auto auto auto;    
}
.osd-paperjs-annotation .dropdown.polygon-toolbar button[data-action="simplify"]{
    margin-right:0.2em;
}
/* end polygon-toolbar styles */

/* linestring-toolbar styles */
.osd-paperjs-annotation .dropdown.linestring-toolbar{
    grid-template-columns: auto minmax(8em, 1fr) auto auto;
}
/* end linestring-toolbar styles */

/* ruler-toolbar styles: single length row + collapsible details panel (column layout) */
.osd-paperjs-annotation .dropdown.ruler-toolbar{
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 0.5em;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    font-size: 12px;
    line-height: 1.35;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-length-row{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 0.35rem;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-length-value{
    font-variant-numeric: tabular-nums;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-toggle{
    display: flex;
    margin-left: auto;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-panel{
    margin-top: 0.35rem;
    padding-top: 0.35rem;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-panel[hidden]{
    display: none !important;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content{
    display: grid;
    grid-template-columns: minmax(7.5rem, auto) minmax(4.5rem, 1fr);
    column-gap: 0.5rem;
    row-gap: 0.35rem;
    min-width: 0;
    align-items: center;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row{
    display: contents;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row > label,
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row > .ruler-detail-label{
    justify-self: end;
    text-align: right;
    color: #333;
    font-weight: 500;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row > .ruler-detail-value{
    justify-self: stretch;
    font-variant-numeric: tabular-nums;
    color: #222;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-instructions{
    grid-column: 1 / -1;
    color: #555;
    margin-bottom: 0.15rem;
    min-width: 0;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content input,
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content select{
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    height: 1.65rem;
    padding: 0 0.35rem;
    border: 1px solid #bbb;
    border-radius: 4px;
    background: #fff;
    font: inherit;
    color: inherit;
}
.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content select{
    padding-right: 0.15rem;
}
/* end ruler-toolbar styles */
.osd-paperjs-annotation canvas.selectable-layer{
    cursor:pointer;
}
.osd-paperjs-annotation canvas.fov-edit-hover{
    cursor: move;
}
.osd-paperjs-annotation canvas.fov-edit-grabbing{
    cursor: grabbing;
}
.osd-paperjs-annotation canvas.point-tool-grab{
    cursor:grab;
}
.osd-paperjs-annotation canvas.point-tool-grabbing{
    cursor:grabbing;
}
.osd-paperjs-annotation canvas.rectangle-tool-move{
    cursor: move;
}
.osd-paperjs-annotation canvas.rectangle-tool-resize{
    cursor:nesw-resize;
}
.osd-paperjs-annotation canvas.transform-tool-move{
    cursor: move;
}
.osd-paperjs-annotation canvas.transform-tool-resize{
    cursor:nesw-resize;
}
.osd-paperjs-annotation canvas.transform-tool-rotate{
    cursor: pointer;
}
.osd-paperjs-annotation .tool-action[data-tool-action="segment"]{
    cursor:move;
}
.osd-paperjs-annotation .tool-action[data-tool-action="stroke"]{
    cursor:copy;
}
.osd-paperjs-annotation .tool-action[data-tool-action="segment-erase"]{
    cursor:not-allowed;
}
.osd-paperjs-annotation .tool-action[data-tool-action="colorpicker"]{
    cursor:none;
}

/* wand-toolbar styles */
.osd-paperjs-annotation .dropdown.wand-toolbar{
    grid-template-columns: 5em 1fr auto auto;
}

.osd-paperjs-annotation .wand-toolbar .threshold-container{
    display:flex;
    flex-direction:column;
}
.osd-paperjs-annotation .wand-toolbar .threshold-container label, .osd-paperjs-annotation .wand-toolbar .label{
    margin-bottom:0;
    font-size:0.8em;
}
/* .wand-toolbar .toggle .btn{
    padding:auto 4px;
    line-height:1;
} */
/* .wand-toolbar .toggle.btn-primary{
    margin-bottom:0;
} */
.osd-paperjs-annotation .wand-toolbar .toggles{
    display:grid;
    column-gap:2px;
    grid-template-columns:7em 5em 8em;
}
.osd-paperjs-annotation .wand-toolbar .option-toggle{
    display:grid;
    grid-template-rows:auto auto;
    cursor: pointer;
    user-select: none;
    -webkit-user-select:none;
}
.osd-paperjs-annotation .wand-toolbar .option-toggle:hover .option{
    background-color:darkgray;
}
.osd-paperjs-annotation .wand-toolbar .option-toggle .option:not(.selected){
    display:none;
}
/* End wand-toolbar styles */

.osd-paperjs-annotation .viewer-controls-topleft{
    display:flex;
}

/* style-toolbar styles */

.osd-paperjs-annotation .style-toolbar .style-row{
    display:grid;
    grid-template-columns:auto auto auto auto;
    column-gap:0.5em;
    align-items:center;
}
.osd-paperjs-annotation .style-toolbar .style-item{
    display:inline-block;
    width:7em;
    white-space: nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    padding-left:0.5em;
    cursor:pointer;
}
.osd-paperjs-annotation .style-toolbar .style-item.selected{
    outline:medium lightskyblue solid;
}
.osd-paperjs-annotation .style-toolbar .hierarchy-up{
    cursor:pointer;
    padding:0 0.5em;
}
.osd-paperjs-annotation .style-toolbar input[type="number"]{
    width:3.5em;
}
.osd-paperjs-annotation .style-toolbar .colorpicker-row.hidden{
    display:none;
}
.osd-paperjs-annotation .style-toolbar .colorpicker-row{
    display:grid;
    grid-template-columns:repeat(4,auto)
}
.osd-paperjs-annotation .style-toolbar .preview{
    position:relative;
    display:block;
    background: repeating-conic-gradient(#d0d0d0 0% 25%, white 0% 50%) 
              50% / 20px 20px
}
.osd-paperjs-annotation .style-toolbar .preview::after{
    /* This is just so the height is set correctly since children are absolute positioned */
    content:'Preview';
    visibility:hidden;
}
.osd-paperjs-annotation .style-toolbar .preview .bg{
    display:block;
    position:absolute;
    outline:thin solid black;
    top:0;
    left:0;
    bottom:0;
    right:0;
}
.osd-paperjs-annotation .style-toolbar .preview .text{
    display:block;
    position:absolute;
    padding:0 0.2em;
}
.osd-paperjs-annotation .style-toolbar input[type="range"]{
    display:inline-block;
}

/* end style-toolbar styles */


.osd-paperjs-annotation .new-feature,.osd-paperjs-annotation .new-feature-collection{
    cursor:pointer;
}
.osd-paperjs-annotation .new-feature:hover,.osd-paperjs-annotation .new-feature-collection:hover{
    background-color:antiquewhite;
    outline:thin gray solid;
}
/* Annotation UI File Dialog Styles*/
.osd-paperjs-annotation .annotation-ui-filedialog{
    display:grid;
    grid-template-columns: auto auto auto;
}
.osd-paperjs-annotation .annotation-ui-filedialog>div{
    padding: 0 0.3em;
}
.osd-paperjs-annotation .annotation-ui-filedialog .featurecollection-selection{
    border-right:thin gray solid;
    border-left:thin gray solid;
    width:15em;
    overflow-x:hidden;
}
.osd-paperjs-annotation .annotation-ui-filedialog .featurecollection-list{
    display:flex;
    flex-direction:column;
    overflow:auto;
}
.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key-list::before{
    content:'Saved in local storage:';
    display:block;
    color:gray;
}
.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key-list:empty::after{
    content:'No items were found in local storage';
    font-style:italic;
    color:gray;
}
.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key{
    cursor:pointer;
}
.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key:hover{
    background-color:lightgoldenrodyellow;
}
.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key-test.key-exists::after{
    content: '(overwrite)';
    font-weight:bold;
    background-color:rgb(190, 99, 66);
    color:white;
    padding:0 0.2em;
}
.osd-paperjs-annotation .annotation-ui-filedialog .finalize-panel{
    width:15em;
    overflow-x:hidden;
}
.osd-paperjs-annotation .annotation-ui-filedialog .header{
    white-space: nowrap;
    border-bottom:thin gray solid;
    padding-bottom:2px;
    margin-bottom:2px;
}
.osd-paperjs-annotation .annotation-ui-filedialog button{
    display:block;
}

.osd-paperjs-annotation .annotation-ui-filedialog .file-actions{
    display:flex;
    flex-direction:column;
}
.osd-paperjs-annotation .annotation-ui-filedialog .file-actions hr{
    margin: 5px 0;
}

.osd-paperjs-annotation button[disabled]{
    opacity:0.3;
}

.osd-paperjs-annotation .dropdown button[data-action="erase"].active{
    background-color:rgb(187, 86, 86);

}
.osd-paperjs-annotation .feature .bounding-element{
    margin-right:-1.2em;
}
.osd-paperjs-annotation .feature .bounding-element:not(.active){
    visibility:visible;
    color:lightgray;
}
.osd-paperjs-annotation .feature .bounding-element.active{
    visibility:visible;
    color:black;
}
.osd-paperjs-annotation .feature:not(:hover) .bounding-element:not(.active){
    visibility:hidden;
}

.osd-paperjs-annotation .hidden{
    display:none;
}

.osd-paperjs-annotation .draganddrop-dragging{
    opacity:0.3;
}
.osd-paperjs-annotation .draganddrop-hide{
    display:none;
}
.osd-paperjs-annotation .draganddrop-drop-target{
    outline:thick rgb(112, 111, 111) solid;
}
.osd-paperjs-annotation .draganddrop-drop-target:hover{
    outline-color:black;
}
.osd-paperjs-annotation .draganddrop-drop-target>*>*{
    pointer-events:none;
}
.osd-paperjs-annotation .draganddrop-placeholder{
    border: thin black solid;
    border-radius:2px;
}
.osd-paperjs-annotation .draganddrop-placeholder>*{
    visibility:hidden;
}

/* From bootstrap */
.osd-paperjs-annotation input[type=range] {
    display: block;
    width: 100%;
}
.osd-paperjs-annotation .btn {
    display: inline-block;
    padding: 2px 8px;
    margin-bottom: 0;
    font-size: 14px;
    /* font-weight: 400; */
    /* line-height: 1.42857143; */
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    /* -ms-touch-action: manipulation;
    touch-action: manipulation; */
    cursor: pointer;
    /* -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none; */
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    /* border-radius: 4px; */
}
.osd-paperjs-annotation .btn.btn-sm{
    font-size:12px;
}

.osd-paperjs-annotation .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.125em;
}
/* Items with [data-action] are supposed to be clickable but if the sub-object gets the click it doesn't work, so stop pointer events on children */
.osd-paperjs-annotation [data-action]>*{
    pointer-events:none;
}

.osd-paperjs-annotation .rotate-by{
    transform:rotate(var(--rotate-angle));
}`, "",{"version":3,"sources":["webpack://./src/css/annotationui.css"],"names":[],"mappings":"AAAA,2FAA2F;AAC3F;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE;AACF,8GAA8G;AAC9G;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,UAAU;IACV,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mDAAmD;IACnD,sBAAsB;IACtB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,QAAQ;AACZ;AACA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,wDAAwD;IACxD,WAAW;AACf;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,SAAS;AACb;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;;IAEI,qCAAqC;IACrC,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,6CAA6C;AACjD;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI;AACJ;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,SAAS,EAAE,wGAAwG;AACvH;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA,0FAA0F;AAC1F;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,OAAO;IACP,6BAA6B;IAC7B,cAAc;IACd,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,iCAAiC;IACjC,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;AACA,0EAA0E,gBAAgB,EAAE;AAC5F,+EAA+E,gBAAgB,EAAE;AACjG,0EAA0E,gBAAgB,EAAE;AAC5F;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,0BAA0B;AAC9B;AACA,yBAAyB;AACzB;IACI,sDAAsD;AAC1D;AACA,6BAA6B;;AAE7B,2BAA2B;AAC3B;IACI,mDAAmD;AACvD;AACA;IACI,kBAAkB;AACtB;AACA,+BAA+B;;AAE/B,8BAA8B;AAC9B;IACI,sDAAsD;AAC1D;AACA,kCAAkC;;AAElC,wFAAwF;AACxF;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,qEAAqE;IACrE,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,yCAAyC;AAC7C;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,+DAA+D;IAC/D,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;AACA;;IAEI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA,6BAA6B;AAC7B;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;;;GAGG;AACH;;GAEG;AACH;IACI,YAAY;IACZ,cAAc;IACd,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA,4BAA4B;;AAE5B;IACI,YAAY;AAChB;;AAEA,yBAAyB;;AAEzB;IACI,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ;AACJ;AACA;IACI,iBAAiB;IACjB,aAAa;IACb;;AAEJ;AACA;IACI,uFAAuF;IACvF,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,KAAK;IACL,MAAM;IACN,QAAQ;IACR,OAAO;AACX;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB;;AAEA,6BAA6B;;;AAG7B;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA,oCAAoC;AACpC;IACI,YAAY;IACZ,qCAAqC;AACzC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,aAAa;AACjB;AACA;IACI,iCAAiC;IACjC,aAAa;IACb,UAAU;AACd;AACA;IACI,8CAA8C;IAC9C,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,eAAe;AACnB;AACA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;;AAErC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB;iCAC6B;IAC7B,eAAe;IACf;;4BAEwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;AAC5B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,wBAAwB;AAC5B;AACA,mJAAmJ;AACnJ;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":["/* Generated from annotationui.unscoped.css — edit that file, then run: npm run scope-css */\n/**\n * OpenSeadragon paperjs overlay plugin based on paper.js\n * @version 0.7.6\n * \n * Includes additional open source libraries which are subject to copyright notices\n * as indicated accompanying those segments of code.\n * \n * Original code:\n * Copyright (c) 2022-2026, Thomas Pearce\n * All rights reserved.\n * \n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n * \n * * Redistributions of source code must retain the above copyright notice, this\n *   list of conditions and the following disclaimer.\n * \n * * Redistributions in binary form must reproduce the above copyright notice,\n *   this list of conditions and the following disclaimer in the documentation\n *   and/or other materials provided with the distribution.\n * \n * * Neither the name of osd-paperjs-annotation nor the names of its\n *   contributors may be used to endorse or promote products derived from\n *   this software without specific prior written permission.\n * \n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\"\n * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE\n * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL\n * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR\n * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER\n * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,\n * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n * \n */\n/* Edit this file, then run: npm run scope-css (writes annotationui.css with .osd-paperjs-annotation scope). */\nbody.annotation-ui-noselect{\n    user-select:none;\n}\n.osd-paperjs-annotation .ui-dialog{\n    font-size:14px;\n}\n.osd-paperjs-annotation .ui-dialog, .osd-paperjs-annotation .ui-dialog-content {\n    box-sizing: content-box;\n}\n.osd-paperjs-annotation .flex-row{\n    display:flex;\n    flex-direction:row;\n}\n.osd-paperjs-annotation .annotation-ui-mainwindow .templates{\n    display:none;\n}\n.osd-paperjs-annotation .annotation-ui-mainwindow{\n    height:100%;\n    width:16em;\n    min-width:12em;\n    color:black;\n    overflow:hidden;\n    display:grid;\n    grid-template-rows: auto auto minmax(4em, 1fr) auto;\n    border:thin gray solid;\n    padding:2px;\n    box-sizing:border-box;\n}\n.osd-paperjs-annotation .annotation-visibility-controls{\n    display:flex;\n    flex-grow:0;\n    flex-shrink:0;\n    border-bottom:thin gray solid;\n    padding-bottom:2px;\n    margin-bottom:2px;\n}\n.osd-paperjs-annotation .annotation-visibility-controls .visibility-buttons{\n    flex-grow:0;\n    display:flex;\n    margin-right:5px;\n}\n.osd-paperjs-annotation .annotation-visibility-controls .annotation-opacity-container{\n    flex-grow:1;\n}\n.osd-paperjs-annotation .annotation-ui-mainwindow button.btn{\n    padding:0 3px;\n}\n.osd-paperjs-annotation .file-button{\n    padding:0.1em 0.5em;\n    margin-right:0.3em;\n}\n.osd-paperjs-annotation .annotation-ui label{\n    margin:0;\n}\n.osd-paperjs-annotation .annotation-ui-feature-collections{\n    overflow:auto;\n    border-bottom:thin gray solid;\n}\n.osd-paperjs-annotation .annotation-ui-feature-collections:empty::before {\n    content: 'Click below to begin a new feature collection';\n    color: gray;\n}\n.osd-paperjs-annotation .feature-collection{\n    border: thin transparent solid;\n    padding:2px;\n    opacity:0.1;\n}\n.osd-paperjs-annotation .annotation-ui-feature-collections .feature-collection{\n    transition: opacity 1s;\n}\n.osd-paperjs-annotation .annotation-ui-feature-collections .feature-collection.inserted:not(.trashed):not(.draganddrop-dragging){\n    opacity:1;\n}\n.osd-paperjs-annotation .annotation-ui-feature-collections .feature-collection:not(.trashed).selected{\n    border:thin black solid;\n    background-color:azure;\n} \n.osd-paperjs-annotation .annotation-ui-feature-collections\n    .feature-collection:not(.trashed,.annotation-hidden,.selected):hover,.osd-paperjs-annotation .feature-collection.svg-hovered:not(.trashed):not(.annotation-hidden){\n    background-color:lightgoldenrodyellow;\n    border:thin black solid;\n}\n.osd-paperjs-annotation .feature-collection.annotation-hidden [data-action=\"hide\"]{\n    display:none;\n}\n.osd-paperjs-annotation .feature-collection:not(.annotation-hidden) [data-action=\"show\"]{\n    display:none;\n}\n.osd-paperjs-annotation .feature-collection.annotation-hidden .features{\n    pointer-events:none;\n    opacity:50%;\n}\n.osd-paperjs-annotation .annotation-ui-feature-collections .name{\n    font-weight:bold;\n}\n.osd-paperjs-annotation .annotation-details{\n    flex-grow:1;\n}\n.osd-paperjs-annotation .feature-item{\n    margin-left:1em;\n}\n\n.osd-paperjs-annotation .feature-collection [data-action], .osd-paperjs-annotation .feature [data-action]{\n    margin-left:0.2em;\n}\n.osd-paperjs-annotation .hoverable-actions:not(:hover) .onhover{\n    visibility:hidden;\n}\n.osd-paperjs-annotation .hoverable-actions:hover .editablecontent .onhover {\n    visibility:visible;\n}\n.osd-paperjs-annotation .feature-collection.trashed{\n    background-color:darkred;\n    opacity:0.3;\n    pointer-events:none;\n}\n.osd-paperjs-annotation .annotation-header{\n    display:grid;\n    grid-template-columns:auto 1fr auto auto auto;\n}\n.osd-paperjs-annotation .feature-collection.trashed .annotation-header [data-action=\"trash\"]{\n    pointer-events:all;\n    visibility:visible;\n}\n.osd-paperjs-annotation .feature-collection .toggle-list{\n    flex-grow:0\n}\n.osd-paperjs-annotation .feature-collection .features{\n    flex-grow:1;\n}\n.osd-paperjs-annotation .features.collapsed .features-list{\n    display:none;\n}\n.osd-paperjs-annotation .features:not(.collapsed) .features-summary{\n    display:none;\n}\n.osd-paperjs-annotation .features.collapsed [data-action=\"collapse-up\"]{\n    display:none;\n}\n.osd-paperjs-annotation .features:not(.collapsed) [data-action=\"collapse-down\"]{\n    display:none;\n}\n.osd-paperjs-annotation .features-summary:not([data-num-elements=\"1\"]) .pluralize::before{\n    content:'s';\n}\n.osd-paperjs-annotation .feature.selected{\n    background-color:green;\n}\n.osd-paperjs-annotation .feature{\n    cursor:default;\n}\n.osd-paperjs-annotation .annotation-ui-mainwindow.disabled .disable-when-annotations-hidden{\n    opacity:0.5;\n    pointer-events:none;\n    cursor:not-allowed;\n}\n.osd-paperjs-annotation .annotation-ui-mainwindow.deactivated .disable-when-deactivated{\n    opacity:0.5;\n    pointer-events:none;\n    cursor:not-allowed;\n}\n\n.osd-paperjs-annotation .annotation-ui-grid{\n    display: grid;\n    grid-template-rows: auto 1fr auto;\n    grid-template-columns: auto 1fr auto;\n    width: 100%;\n    height: 100%;\n    background-color:white;\n}\n.osd-paperjs-annotation .annotation-ui-grid .center{\n    grid-column: 2 / 3;\n    grid-row: 2 / 3;\n    position:relative;\n    z-index:0; /* reset the z-index basis for this container so children can be manipulated independently of siblings */\n}\n.osd-paperjs-annotation .annotation-ui-grid .top {\n    grid-column: 1 / 3;\n    grid-row: 1 / 2;\n    text-align:center;\n    border-bottom:thin gray solid;\n}\n.osd-paperjs-annotation .annotation-ui-grid .bottom {\n    grid-column: 1 / 3;\n    grid-row: 3 / 4;\n}\n.osd-paperjs-annotation .annotation-ui-grid .left {\n    grid-column: 1 / 2;\n    grid-row: 2 / 3;\n}\n.osd-paperjs-annotation .annotation-ui-grid .right {\n    grid-column: 3 / 4;\n    grid-row: 1 / 4;\n    position:relative;\n}\n/* Scope wrapper fills the grid cell so .annotation-ui-mainwindow { height: 100% } works */\n.annotation-ui-grid .right > .osd-paperjs-annotation {\n    height: 100%;\n}\n.osd-paperjs-annotation .annotation-ui-grid .resize-right{\n    width: 15px;\n    left: -15px;\n    position: absolute;\n    background-color: rgb(196, 196, 196);\n    cursor: grab;\n    text-align:center;\n    user-select:none;\n    top:50%;\n    transform: translate(0, -50%);\n    padding:10px 0;\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n}\n.osd-paperjs-annotation .annotation-ui-grid .resize-right::before{\n    content:'||';\n}\n.osd-paperjs-annotation .annotation-ui-grid .resize-right.resizing{\n    cursor:grabbing;\n}\n.osd-paperjs-annotation .annotation-ui-grid .right:not(:hover) .resize-right{\n    display:none;\n}\n\n.osd-paperjs-annotation .annotation-ui-drawing-toolbar .pseudohidden, .osd-paperjs-annotation .annotation-ui-drawing-toolbar .invisible{\n    visibility:hidden;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    padding:0;\n    border:none;\n}\n.osd-paperjs-annotation .annotation-ui-drawing-toolbar{\n    background-color:lightgray;\n    display: inline-block;\n    max-width:100%;\n    text-align:left;\n}\n.osd-paperjs-annotation .annotation-ui-drawing-toolbar button[disabled]{\n    pointer-events:none;\n    cursor:not-allowed;\n    border:thin solid transparent;\n}\n.osd-paperjs-annotation .annotation-ui-drawing-toolbar button:not([disabled]){\n    border:thin rgb(195, 195, 195) solid;\n}\n.osd-paperjs-annotation .annotation-ui-drawing-toolbar button:not([disabled]):hover{\n    border:thin rgb(41, 41, 41) solid;\n    z-index:2;\n}\n.osd-paperjs-annotation .annotation-ui-drawing-toolbar .dropdowns>*:not(.active){\n    display:none;\n}\n.osd-paperjs-annotation .annotation-ui-buttonbar>.btn.active{\n    color:black;\n    background-color:darkgray;\n}\n.osd-paperjs-annotation .annotation-ui-buttonbar>.btn:not(.active){\n    color:rgb(62, 62, 62);\n    background-color:lightgrey;\n}\n.osd-paperjs-annotation .dropdowns-container{\n    position:relative;\n    background-color:inherit;\n}\n.osd-paperjs-annotation .dropdowns{\n    color:black;\n    position:absolute;\n    background-color:inherit;\n    min-width:100%;\n}\n.osd-paperjs-annotation .dropdowns:has(.dropdown.active .ruler-toolbar) { min-width: 280px; }\n.osd-paperjs-annotation .dropdowns:has(.dropdown.active .linestring-toolbar) { min-width: 280px; }\n.osd-paperjs-annotation .dropdowns:has(.dropdown.active .brush-toolbar) { min-width: 280px; }\n.osd-paperjs-annotation .dropdown{\n    width:100%;\n    display:grid;\n    vertical-align: middle;\n    column-gap:1em;\n    grid-template-columns:auto;\n}\n/* brush-toolbar styles */\n.osd-paperjs-annotation .dropdown.brush-toolbar{\n    grid-template-columns: auto minmax(8em, 1fr) auto auto;    \n}\n/* end brush-toolbar styles */\n\n/* polygon-toolbar styles */\n.osd-paperjs-annotation .dropdown.polygon-toolbar{\n    grid-template-columns: 1fr auto auto auto auto auto;    \n}\n.osd-paperjs-annotation .dropdown.polygon-toolbar button[data-action=\"simplify\"]{\n    margin-right:0.2em;\n}\n/* end polygon-toolbar styles */\n\n/* linestring-toolbar styles */\n.osd-paperjs-annotation .dropdown.linestring-toolbar{\n    grid-template-columns: auto minmax(8em, 1fr) auto auto;\n}\n/* end linestring-toolbar styles */\n\n/* ruler-toolbar styles: single length row + collapsible details panel (column layout) */\n.osd-paperjs-annotation .dropdown.ruler-toolbar{\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding-bottom: 0.5em;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n    font-size: 12px;\n    line-height: 1.35;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-length-row{\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: 0.35rem;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-length-value{\n    font-variant-numeric: tabular-nums;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-toggle{\n    display: flex;\n    margin-left: auto;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-panel{\n    margin-top: 0.35rem;\n    padding-top: 0.35rem;\n    border-top: 1px solid rgba(0, 0, 0, 0.12);\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-panel[hidden]{\n    display: none !important;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content{\n    display: grid;\n    grid-template-columns: minmax(7.5rem, auto) minmax(4.5rem, 1fr);\n    column-gap: 0.5rem;\n    row-gap: 0.35rem;\n    min-width: 0;\n    align-items: center;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row{\n    display: contents;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row > label,\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row > .ruler-detail-label{\n    justify-self: end;\n    text-align: right;\n    color: #333;\n    font-weight: 500;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-detail-row > .ruler-detail-value{\n    justify-self: stretch;\n    font-variant-numeric: tabular-nums;\n    color: #222;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-instructions{\n    grid-column: 1 / -1;\n    color: #555;\n    margin-bottom: 0.15rem;\n    min-width: 0;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content input,\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content select{\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    height: 1.65rem;\n    padding: 0 0.35rem;\n    border: 1px solid #bbb;\n    border-radius: 4px;\n    background: #fff;\n    font: inherit;\n    color: inherit;\n}\n.osd-paperjs-annotation .dropdown.ruler-toolbar .ruler-details-content select{\n    padding-right: 0.15rem;\n}\n/* end ruler-toolbar styles */\n.osd-paperjs-annotation canvas.selectable-layer{\n    cursor:pointer;\n}\n.osd-paperjs-annotation canvas.fov-edit-hover{\n    cursor: move;\n}\n.osd-paperjs-annotation canvas.fov-edit-grabbing{\n    cursor: grabbing;\n}\n.osd-paperjs-annotation canvas.point-tool-grab{\n    cursor:grab;\n}\n.osd-paperjs-annotation canvas.point-tool-grabbing{\n    cursor:grabbing;\n}\n.osd-paperjs-annotation canvas.rectangle-tool-move{\n    cursor: move;\n}\n.osd-paperjs-annotation canvas.rectangle-tool-resize{\n    cursor:nesw-resize;\n}\n.osd-paperjs-annotation canvas.transform-tool-move{\n    cursor: move;\n}\n.osd-paperjs-annotation canvas.transform-tool-resize{\n    cursor:nesw-resize;\n}\n.osd-paperjs-annotation canvas.transform-tool-rotate{\n    cursor: pointer;\n}\n.osd-paperjs-annotation .tool-action[data-tool-action=\"segment\"]{\n    cursor:move;\n}\n.osd-paperjs-annotation .tool-action[data-tool-action=\"stroke\"]{\n    cursor:copy;\n}\n.osd-paperjs-annotation .tool-action[data-tool-action=\"segment-erase\"]{\n    cursor:not-allowed;\n}\n.osd-paperjs-annotation .tool-action[data-tool-action=\"colorpicker\"]{\n    cursor:none;\n}\n\n/* wand-toolbar styles */\n.osd-paperjs-annotation .dropdown.wand-toolbar{\n    grid-template-columns: 5em 1fr auto auto;\n}\n\n.osd-paperjs-annotation .wand-toolbar .threshold-container{\n    display:flex;\n    flex-direction:column;\n}\n.osd-paperjs-annotation .wand-toolbar .threshold-container label, .osd-paperjs-annotation .wand-toolbar .label{\n    margin-bottom:0;\n    font-size:0.8em;\n}\n/* .wand-toolbar .toggle .btn{\n    padding:auto 4px;\n    line-height:1;\n} */\n/* .wand-toolbar .toggle.btn-primary{\n    margin-bottom:0;\n} */\n.osd-paperjs-annotation .wand-toolbar .toggles{\n    display:grid;\n    column-gap:2px;\n    grid-template-columns:7em 5em 8em;\n}\n.osd-paperjs-annotation .wand-toolbar .option-toggle{\n    display:grid;\n    grid-template-rows:auto auto;\n    cursor: pointer;\n    user-select: none;\n    -webkit-user-select:none;\n}\n.osd-paperjs-annotation .wand-toolbar .option-toggle:hover .option{\n    background-color:darkgray;\n}\n.osd-paperjs-annotation .wand-toolbar .option-toggle .option:not(.selected){\n    display:none;\n}\n/* End wand-toolbar styles */\n\n.osd-paperjs-annotation .viewer-controls-topleft{\n    display:flex;\n}\n\n/* style-toolbar styles */\n\n.osd-paperjs-annotation .style-toolbar .style-row{\n    display:grid;\n    grid-template-columns:auto auto auto auto;\n    column-gap:0.5em;\n    align-items:center;\n}\n.osd-paperjs-annotation .style-toolbar .style-item{\n    display:inline-block;\n    width:7em;\n    white-space: nowrap;\n    overflow:hidden;\n    text-overflow:ellipsis;\n    padding-left:0.5em;\n    cursor:pointer;\n}\n.osd-paperjs-annotation .style-toolbar .style-item.selected{\n    outline:medium lightskyblue solid;\n}\n.osd-paperjs-annotation .style-toolbar .hierarchy-up{\n    cursor:pointer;\n    padding:0 0.5em;\n}\n.osd-paperjs-annotation .style-toolbar input[type=\"number\"]{\n    width:3.5em;\n}\n.osd-paperjs-annotation .style-toolbar .colorpicker-row.hidden{\n    display:none;\n}\n.osd-paperjs-annotation .style-toolbar .colorpicker-row{\n    display:grid;\n    grid-template-columns:repeat(4,auto)\n}\n.osd-paperjs-annotation .style-toolbar .preview{\n    position:relative;\n    display:block;\n    background: repeating-conic-gradient(#d0d0d0 0% 25%, white 0% 50%) \n              50% / 20px 20px\n}\n.osd-paperjs-annotation .style-toolbar .preview::after{\n    /* This is just so the height is set correctly since children are absolute positioned */\n    content:'Preview';\n    visibility:hidden;\n}\n.osd-paperjs-annotation .style-toolbar .preview .bg{\n    display:block;\n    position:absolute;\n    outline:thin solid black;\n    top:0;\n    left:0;\n    bottom:0;\n    right:0;\n}\n.osd-paperjs-annotation .style-toolbar .preview .text{\n    display:block;\n    position:absolute;\n    padding:0 0.2em;\n}\n.osd-paperjs-annotation .style-toolbar input[type=\"range\"]{\n    display:inline-block;\n}\n\n/* end style-toolbar styles */\n\n\n.osd-paperjs-annotation .new-feature,.osd-paperjs-annotation .new-feature-collection{\n    cursor:pointer;\n}\n.osd-paperjs-annotation .new-feature:hover,.osd-paperjs-annotation .new-feature-collection:hover{\n    background-color:antiquewhite;\n    outline:thin gray solid;\n}\n/* Annotation UI File Dialog Styles*/\n.osd-paperjs-annotation .annotation-ui-filedialog{\n    display:grid;\n    grid-template-columns: auto auto auto;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog>div{\n    padding: 0 0.3em;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .featurecollection-selection{\n    border-right:thin gray solid;\n    border-left:thin gray solid;\n    width:15em;\n    overflow-x:hidden;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .featurecollection-list{\n    display:flex;\n    flex-direction:column;\n    overflow:auto;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key-list::before{\n    content:'Saved in local storage:';\n    display:block;\n    color:gray;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key-list:empty::after{\n    content:'No items were found in local storage';\n    font-style:italic;\n    color:gray;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key{\n    cursor:pointer;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key:hover{\n    background-color:lightgoldenrodyellow;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .localstorage-key-test.key-exists::after{\n    content: '(overwrite)';\n    font-weight:bold;\n    background-color:rgb(190, 99, 66);\n    color:white;\n    padding:0 0.2em;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .finalize-panel{\n    width:15em;\n    overflow-x:hidden;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .header{\n    white-space: nowrap;\n    border-bottom:thin gray solid;\n    padding-bottom:2px;\n    margin-bottom:2px;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog button{\n    display:block;\n}\n\n.osd-paperjs-annotation .annotation-ui-filedialog .file-actions{\n    display:flex;\n    flex-direction:column;\n}\n.osd-paperjs-annotation .annotation-ui-filedialog .file-actions hr{\n    margin: 5px 0;\n}\n\n.osd-paperjs-annotation button[disabled]{\n    opacity:0.3;\n}\n\n.osd-paperjs-annotation .dropdown button[data-action=\"erase\"].active{\n    background-color:rgb(187, 86, 86);\n\n}\n.osd-paperjs-annotation .feature .bounding-element{\n    margin-right:-1.2em;\n}\n.osd-paperjs-annotation .feature .bounding-element:not(.active){\n    visibility:visible;\n    color:lightgray;\n}\n.osd-paperjs-annotation .feature .bounding-element.active{\n    visibility:visible;\n    color:black;\n}\n.osd-paperjs-annotation .feature:not(:hover) .bounding-element:not(.active){\n    visibility:hidden;\n}\n\n.osd-paperjs-annotation .hidden{\n    display:none;\n}\n\n.osd-paperjs-annotation .draganddrop-dragging{\n    opacity:0.3;\n}\n.osd-paperjs-annotation .draganddrop-hide{\n    display:none;\n}\n.osd-paperjs-annotation .draganddrop-drop-target{\n    outline:thick rgb(112, 111, 111) solid;\n}\n.osd-paperjs-annotation .draganddrop-drop-target:hover{\n    outline-color:black;\n}\n.osd-paperjs-annotation .draganddrop-drop-target>*>*{\n    pointer-events:none;\n}\n.osd-paperjs-annotation .draganddrop-placeholder{\n    border: thin black solid;\n    border-radius:2px;\n}\n.osd-paperjs-annotation .draganddrop-placeholder>*{\n    visibility:hidden;\n}\n\n/* From bootstrap */\n.osd-paperjs-annotation input[type=range] {\n    display: block;\n    width: 100%;\n}\n.osd-paperjs-annotation .btn {\n    display: inline-block;\n    padding: 2px 8px;\n    margin-bottom: 0;\n    font-size: 14px;\n    /* font-weight: 400; */\n    /* line-height: 1.42857143; */\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: middle;\n    /* -ms-touch-action: manipulation;\n    touch-action: manipulation; */\n    cursor: pointer;\n    /* -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none; */\n    user-select: none;\n    background-image: none;\n    border: 1px solid transparent;\n    /* border-radius: 4px; */\n}\n.osd-paperjs-annotation .btn.btn-sm{\n    font-size:12px;\n}\n\n.osd-paperjs-annotation .icon {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.125em;\n}\n/* Items with [data-action] are supposed to be clickable but if the sub-object gets the click it doesn't work, so stop pointer events on children */\n.osd-paperjs-annotation [data-action]>*{\n    pointer-events:none;\n}\n\n.osd-paperjs-annotation .rotate-by{\n    transform:rotate(var(--rotate-angle));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
